export default ["(", ")", "&&", "||", "!", ">", "<", "<=", ">=", "==", "!=", "+", "-", "*", "/"]